import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Divider,
  Rating,
  LinearProgress,
} from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  Comment as CommentIcon,
} from '@mui/icons-material';
import PropTypes from 'prop-types';

const TemplateStatistics = ({ templateStats, onOpenFeedbackDialog }) => {
  return (
    <Paper sx={{ p: 3, height: '100%' }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <TrendingUpIcon sx={{ mr: 1 }} />
        Template Statistics
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2">Total Executions</Typography>
          <Typography variant="h6" color="primary">
            {templateStats.totalExecutions}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2">Success Rate</Typography>
          <Typography variant="h6" color="success.main">
            {templateStats.successRate.toFixed(1)}%
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={templateStats.successRate}
          sx={{ mb: 2, height: 8, borderRadius: 4 }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2">Average Rating</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Rating
              value={templateStats.averageRating}
              readOnly
              size="small"
              precision={0.1}
            />
            <Typography variant="body2" sx={{ ml: 1 }}>
              ({templateStats.averageRating.toFixed(1)})
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2">Total Ratings</Typography>
          <Typography variant="body2">{templateStats.totalRatings}</Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="subtitle2">Last Executed</Typography>
          <Typography variant="body2">
            {templateStats.lastExecuted
              ? new Date(templateStats.lastExecuted).toLocaleDateString()
              : 'Never'}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Button
        variant="outlined"
        fullWidth
        startIcon={<CommentIcon />}
        onClick={onOpenFeedbackDialog}
      >
        Add Feedback
      </Button>
    </Paper>
  );
};

TemplateStatistics.propTypes = {
  templateStats: PropTypes.object.isRequired,
  onOpenFeedbackDialog: PropTypes.func.isRequired,
};

export default TemplateStatistics;
